import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  UnorderedList,
  ListItem,
  VStack,
  Box,
} from '@chakra-ui/react';

const HelpModal = ({ isOpen, onClose, title, content }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack align="stretch" spacing={4}>
            {content}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

// Help content for different pages
export const groupsHelpContent = (
  <>
    <Text>
      The Groups page allows you to organize members into different groups for easier message management.
    </Text>
    <UnorderedList spacing={2}>
      <ListItem>
        <Text fontWeight="bold">Creating Groups</Text>
        <Text>Click the + button in the top right of the groups list to create a new group.</Text>
      </ListItem>
      <ListItem>
        <Text fontWeight="bold">Managing Members</Text>
        <Text>Select a group from the list to view and manage its members. Use the checkboxes next to each name to add or remove members from the group.</Text>
      </ListItem>
      <ListItem>
        <Text fontWeight="bold">Searching</Text>
        <Text>Use the search boxes to filter either the groups list or the members list. The search is case-insensitive and matches any part of the name.</Text>
      </ListItem>
      <ListItem>
        <Text fontWeight="bold">All Members</Text>
        <Text>The "All Members" option at the top of the groups list shows all active members in the system.</Text>
      </ListItem>
      <ListItem>
        <Text fontWeight="bold">Active Members</Text>
        <Text>Only members who have given consent to receive messages (Active status) will be shown in the members list.</Text>
      </ListItem>
    </UnorderedList>
  </>
);

export const contactsHelpContent = (
  <>
    <Text>
      The Members page allows you to manage your contact list for sending messages.
    </Text>
    <Box>
      <Text fontWeight="bold" mb={2}>Search and Filtering</Text>
      <UnorderedList spacing={1}>
        <ListItem>Use the search bar to filter contacts by name, email, or phone number</ListItem>
        <ListItem>Click the "x" in the search bar to clear your search</ListItem>
        <ListItem>Use the status dropdown to filter by consent status</ListItem>
      </UnorderedList>
    </Box>

    <Box mt={4}>
      <Text fontWeight="bold" mb={2}>Sorting</Text>
      <UnorderedList spacing={1}>
        <ListItem>Click any column header to sort by that field</ListItem>
        <ListItem>Sort icons indicate:
          <UnorderedList>
            <ListItem>Gray double arrow (↕): Column is sortable</ListItem>
            <ListItem>Black up arrow (↑): Sorted ascending (A to Z)</ListItem>
            <ListItem>Black down arrow (↓): Sorted descending (Z to A)</ListItem>
          </UnorderedList>
        </ListItem>
      </UnorderedList>
    </Box>

    <Box mt={4}>
      <Text fontWeight="bold" mb={2}>Actions</Text>
      <UnorderedList spacing={1}>
        <ListItem>+ : Add a new contact</ListItem>
        <ListItem>Message (chat): View message history</ListItem>
        <ListItem>Edit (pencil): Modify contact details</ListItem>
        <ListItem>Delete (trash): Remove a contact</ListItem>
      </UnorderedList>
    </Box>

    <Box mt={4}>
      <Text fontWeight="bold" mb={2}>Consent Status Colors</Text>
      <UnorderedList spacing={1}>
        <ListItem>Green: Active consent</ListItem>
        <ListItem>Yellow: Pending consent</ListItem>
        <ListItem>Red: Revoked consent</ListItem>
        <ListItem>Orange: Consented (legacy)</ListItem>
      </UnorderedList>
    </Box>
  </>
);

export default HelpModal;
